import { detect } from 'detect-browser';

export const browserInfo = detect();
